module.exports = __webpack_public_path__ + "static/media/Screenshot_63.8f9d8c61.png";